import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

const initial_value = {
  company_id: "",
  name: "",
  email: "",
  mobile: "",
  whatsapp: "",
  address: "",
  gstin: "",
  igst: false,
  total_order_amount: 0,
  total_paid_amount: 0,
  total_pending_amount: 0,
};

let myModal = {};

export default function ModelViewCompany(props: any) {
  const [save_data, SetSaveData] = useState(initial_value);
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [errors, setErrors] = useState({});
  const [is_read_only, SetIsReadOnaly] = useState(true);

  useEffect(() => {
    console.log("ModelViewCompany On mount :", props);
    let myModal1 = document.getElementById("ViewCompanyModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("event :", event);
      console.log("close_data :", close_data);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.data.is_open) {
      console.log("ModelViewCompany On mount :", props);

      myModal = new bootstrap.Modal(
        document.getElementById("ViewCompanyModal"),
        {}
      );
      myModal.show();
      let value_data = {
        company_id: props.data.record.id,
        name: props.data.record.name,
        email: props.data.record.email,
        mobile: props.data.record.mobile,
        whatsapp: props.data.record.whatsapp,
        address: props.data.record.address,
        gstin: props.data.record.gstin,
        igst: props.data.record.igst,
        total_order_amount: props.data.record.total_order_amount,
        total_paid_amount: props.data.record.total_paid_amount,
        total_pending_amount: props.data.record.total_pending_amount,
      };
      SetSaveData(value_data);
      if (props.data.type == "view") {
        SetIsReadOnaly(true);
      } else {
        SetIsReadOnaly(false);
      }
      console.log("props type 2:", value_data);
    }
  }, [props.data.is_open]);

  async function save(event: any) {
    if (event) event.preventDefault();
    if (
      Object.keys(errors).length === 0 &&
      Object.keys(save_data).length !== 0
    ) {
      console.log("Save Event :", save_data);
      let pass_data = {
        get: {
          brand: id_value.brand_id,
          outlet: id_value.outlet_id,
        },
        post: save_data,
      };
      let response = await api("/outlet/edit_company", pass_data);
      console.log("company edit response :", response);
      if (response.status_code == 200) {
        let item = close_data;
        item.action = "edit";
        item.value = response.response.company[0];
        item.index = props.data.record_index;
        SetCloseData(item);
        SetSaveData(initial_value);
        myModal.hide();
      }
    } else {
      alert("There is an Error!");
    }
  }

  function set(name: any, value: any, event: any) {
    event.persist();

    validate(event, name, value);
    SetSaveData((oldValues) => ({ ...oldValues, [name]: value }));
  }

  const validate = (event: any, name: any, value: any) => {
    //A function to validate each input values
    console.log("name :", name);
    console.log("value  :", value);
    switch (name) {
      case "name":
        if (value.length <= 2) {
          // we will set the error state

          setErrors({
            ...errors,
            name: "Companyname atleast have 3 letters",
          });
        } else {
          // set the error state empty or remove the error for username input

          //omit function removes/omits the value from given object and returns a new object
          let newObj = omit(errors, "name");
          setErrors(newObj);
        }
        break;

      case "email":
        if (
          !new RegExp(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ).test(value)
        ) {
          setErrors({
            ...errors,
            email: "Enter a valid email address",
          });
        } else {
          let newObj = omit(errors, "email");
          setErrors(newObj);
        }
        break;

      case "mobile":
        if (!new RegExp(/^((\\+91-?)|0)?[0-9]{10}$/).test(value)) {
          setErrors({
            ...errors,
            mobile: "mobile should contains 10 numbers",
          });
        } else {
          let newObj = omit(errors, "mobile");
          setErrors(newObj);
        }
        break;

      case "whatsapp":
        if (!new RegExp(/^((\\+91-?)|0)?[0-9]{10}$/).test(value)) {
          setErrors({
            ...errors,
            whatsapp: "whatsapp should contains 10 numbers",
          });
        } else {
          let newObj = omit(errors, "whatsapp");
          setErrors(newObj);
        }
        break;

      case "address":
        if (value.length <= 0) {
          setErrors({
            ...errors,
            address: "Address not vaild",
          });
        } else {
          let newObj = omit(errors, "address");
          setErrors(newObj);
        }
        break;

      case "gstin":
        if (
          !new RegExp(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
          )
        ) {
          setErrors({
            ...errors,
            gstin: "gstin not vaild",
          });
        } else {
          let newObj = omit(errors, "gstin");
          setErrors(newObj);
        }
        break;

      case "total_order_amount":
        if (value == 0) {
          setErrors({
            ...errors,
            total_order_amount: "total order amount not vaild",
          });
        } else {
          let newObj = omit(errors, "total_order_amount");
          setErrors(newObj);
        }
        break;

      case "total_paid_amount":
        if (value == 0) {
          setErrors({
            ...errors,
            total_paid_amount: "total paid amount not vaild",
          });
        } else {
          let newObj = omit(errors, "total_paid_amount");
          setErrors(newObj);
        }
        break;

      case "total_pending_amount":
        if (value == 0) {
          setErrors({
            ...errors,
            total_pending_amount: "total pending amount not vaild",
          });
        } else {
          let newObj = omit(errors, "total_pending_amount");
          setErrors(newObj);
        }
        break;

      default:
        break;
    }
  };

  return (
    <div
      className="modal fade"
      id="ViewCompanyModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              {is_read_only ? "Company Details" : "Edit Company"}
            </h5>
            <button
              type="button"
              className="btn-close"
              // data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            {is_read_only ? null : (
              <p>
                <small>Please fill a correct details</small>
              </p>
            )}

            <form className="row g-3">
              <div className="col-12">
                <label className="form-label">Customer name</label>
                <input
                  type="text"
                  className="form-control"
                  value={save_data.name}
                  onChange={(e) => {
                    set("name", e.target.value, e);
                  }}
                  required
                  readOnly={is_read_only}
                />
                {errors.name && (
                  <small className="text-red">{errors.name}</small>
                )}
              </div>

              <div className="col-md-6 col-12">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={save_data.email}
                  onChange={(e) => {
                    set("email", e.target.value, e);
                  }}
                  required
                  readOnly={is_read_only}
                />
                {errors.email && (
                  <small className="text-red">{errors.email}</small>
                )}
              </div>

              <div className="col-md-6 col-12">
                <label className="form-label">Mobile Number</label>
                <input
                  type="number"
                  className="form-control"
                  value={save_data.mobile}
                  onChange={(e) => {
                    set("mobile", e.target.value, e);
                  }}
                  required
                  readOnly={is_read_only}
                />
                {errors.mobile && (
                  <small className="text-red">{errors.mobile}</small>
                )}
              </div>

              <div className="col-md-6 col-12">
                <label className="form-label">Whatsapp Number</label>
                <input
                  type="number"
                  className="form-control"
                  value={save_data.whatsapp}
                  onChange={(e) => {
                    set("whatsapp", e.target.value, e);
                  }}
                  required
                  readOnly={is_read_only}
                />
                {errors.whatsapp && (
                  <small className="text-red">{errors.whatsapp}</small>
                )}
              </div>

              <div className="col-md-6 col-12">
                <label className="form-label">GST Number</label>
                <input
                  type="text"
                  className="form-control"
                  value={save_data.gstin}
                  onChange={(e) => {
                    set("gstin", e.target.value, e);
                  }}
                  required
                  readOnly={is_read_only}
                />
                {errors.gstin && (
                  <small className="text-red">{errors.gstin}</small>
                )}
              </div>

              {/* <div className="col-md-4 col-4">
                <label className="form-label">Total</label>
                <input
                  type="number"
                  className="form-control"
                  defaultValue={props.data.total_order_amount}
                  onChange={(e) => {
                    set("total_order_amount", e.target.value, e);
                  }}
                  required
                  readOnly={is_read_only}
                />
                {errors.total_order_amount && (
                  <small className="text-red">
                    {errors.total_order_amount}
                  </small>
                )}
              </div>

              <div className="col-md-4 col-4">
                <label className="form-label">Paid</label>
                <input
                  type="number"
                  className="form-control"
                  value={props.data.total_paid_amount}
                  onChange={(e) => {
                    set("total_paid_amount", e.target.value, e);
                  }}
                  required
                  readOnly={is_read_only}
                />
                {errors.total_paid_amount && (
                  <small className="text-red">{errors.total_paid_amount}</small>
                )}
              </div>

              <div className="col-md-4 col-4">
                <label className="form-label">Payable</label>
                <input
                  type="number"
                  className="form-control"
                  value={props.data.total_pending_amount}
                  onChange={(e) => {
                    set("total_pending_amount", e.target.value, e);
                  }}
                  required
                  readOnly={is_read_only}
                />
                {errors.total_pending_amount && (
                  <small className="text-red">
                    {errors.total_pending_amount}
                  </small>
                )}
              </div> */}

              <div className="col-md-2 col-4">
                <label className="form-label d-flex">
                  <input
                    type="checkbox"
                    className="form-check me-2"
                    checked={save_data.igst}
                    required
                    onChange={(e) => {
                      SetSaveData((prevValue: any) => {
                        prevValue.igst = !prevValue.igst;
                        return { ...prevValue };
                      });
                      // set("gstin", e.target.value, e);
                      // SetSaveError(false);
                    }}
                  />
                  IGST
                </label>
              </div>

              <div className="col-12">
                <label className="form-label">Address</label>
                <textarea
                  rows={2}
                  className="form-control"
                  value={save_data.address}
                  onChange={(e) => {
                    set("address", e.target.value, e);
                  }}
                  required
                  readOnly={is_read_only}
                />
                {errors.address && (
                  <small className="text-red">{errors.address}</small>
                )}
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              // data-bs-dismiss="modal"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {!is_read_only ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={save}
              >
                Save
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
